import React, { useState } from "react";
import { Helmet } from "react-helmet";
import Header from "../../components/common/Header";
import Footer from "../../components/common/Footer";

import ContactSection from "../../components/common/ContactSection";
import ContactFillForm from "./ContactSection";

const Contact = () => {
  // Changed: Initial state is null (nothing open)
  const [openIndex, setOpenIndex] = useState(null);

  const toggleExpanded = (index) => {
    // If clicking the same item, close it (null). Otherwise, open the new index.
    setOpenIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <>
      <Helmet>
        <title>ANVIYA Biospecimen Services</title>
      </Helmet>

      <main className="w-full bg-white">
        <Header />
        <ContactFillForm />
        <ContactSection />

        <Footer />
      </main>
    </>
  );
};

export default Contact;
